export const SECOND_IN_MS = 1000
export const MINUTE_IN_SECONDS = 60
export const HOUR_IN_MINUTES = 60
export const HOURS_IN_DAY = 24
export const HOUR_IN_MS = SECOND_IN_MS * MINUTE_IN_SECONDS * HOUR_IN_MINUTES
export const DAY_IN_MS = HOUR_IN_MS * HOURS_IN_DAY
export const FALLBACK_DAYS_IN_HOURS = 72
